import React from 'react'
import AlertModal from '../../../../ui/modals/AlertModal'
import { Button } from 'react-bootstrap'
import confirmIcon from '../../../../../assets/svg/ils/ils-question.svg'
import successIcon from '../../../../../assets/svg/ils/ils-check.svg'
import classNames from 'classnames'

/**
 * Renewal Cycle
 */

export const RenewalCycleConfirmModalToMonthly = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            className="confirm-modal"
            icon={confirmIcon}
            message="Change Renewal Cycle?"
            showFooter={false}
            {...props}
        >
            <p className="subtitle">
                Are you sure to change renewal cycle from <span className="text">“Annual”</span> to <span className="text">“Monthly”</span>? You have to pay <span className="text">$98.9</span> more in a year
            </p>
            <p className="text">Annual Subscription Charges</p>
            <span className="strong">$499.99</span>
            <p className="text">One year charge if paid monthly</p>
            <span className="strong">$598.8</span>
            <Button
                variant="primary"
                block
                size="md"
                onClick={() => props.onHide()}
            >No, Keep Annual</Button>
            <Button
                variant="secondary"
                block
                size="md"
                onClick={() => props.onConfirm()}
            >Yes, Continue</Button>
        </AlertModal>
    )
}

export const RenewalCycleSuccessModalToMonthly = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Cycle Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal Cycle has been changed to <span className="text">“Monthly”</span>. You will be charged for Monthly subscription after your current plan expiring on <span className="text">12/31/2021</span>
            </p>
            <p className="text">Monthly Subscription Charges</p>
            <span className="strong">$49.99</span>
        </AlertModal>
    )
}

export const RenewalCycleSuccessModalToAnnual = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Cycle Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal Cycle has been changed to <span className="text">“Annual”</span>. You will be charged for Annual subscription after your current plan expiring on <span className="text">12/31/2021</span>
            </p>
            <p className="text">Annual Subscription Charges</p>
            <span className="strong">$499.99</span>
            <p className="text">You Will Save</p>
            <span className="strong">$98.8</span>
        </AlertModal>
    )
}

/**
 * Renewal Type
 */

export const RenewalTypeSuccessModalToManual = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Type Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal type has been changed to <span className="text">“Manual Renewal”</span>. We will send you renewal link 4 days before account expiry date.
            </p>
        </AlertModal>
    )
}

export const RenewalTypeSuccessModalToAuto = ({
    lastCardNumber = "X345",
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Type Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal type has been changed to <span className="text">“Auto Renewal”</span>. Your account will be renewed automatically on the expiry date, from your credit card ending <span className="text">“{lastCardNumber}”</span>
            </p>
        </AlertModal>
    )
}

/**
 * Renewal Both
 */

export const RenewalBothConfirmModalToManualToMonthly = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            className="confirm-modal"
            icon={confirmIcon}
            message="Change Renewal Type and Cycle?"
            showFooter={false}
            {...props}
        >
            <p className="subtitle">
                Are you sure to change renewal type to <span className="text">“Manual”</span> and renewal cycle to <span className="text">“Annual”</span> to <span className="text">“Monthly”</span>? changing cycle will cost you <span className="text">$98.9</span> more in a year
            </p>
            <p className="text">Annual Subscription Charges</p>
            <span className="strong">$499.99</span>
            <p className="text">One year charge if paid monthly</p>
            <span className="strong">$598.8</span>
            <Button
                variant="primary"
                block
                size="md"
                onClick={() => props.onHide()}
            >Cancel Changes</Button>
            <Button
                variant="secondary"
                block
                size="md"
                onClick={() => props.onConfirm()}
            >Yes, Continue</Button>
        </AlertModal>
    )
}

export const RenewalBothSuccessModalToManualToMonthly = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Type and Cycle Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal type to <span className="text">“Manual”</span> and renewal cycle to <span className="text">“Annual”</span> to <span className="text">“Monthly”</span> has been changes. You will be charged for Monthly subscription. We will send you renewal link 4 days before account expiry date <span className="text">12/31/2020</span>.
            </p>
            <p className="text">Monthly charge after current plan expires will be</p>
            <span className="strong">$49.99</span>
        </AlertModal>
    )
}

export const RenewalBothSuccessModalToManualToAnnual = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Cycle Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                You renewal Cycle has been changed to <span className="text">“Manual”</span>. You will be charged for Monthly subscription. We will send you renewal link 4 days before account expiry date <span className="text">12/31/2020</span>.
            </p>
            <p className="text">Annual Subscription Charges</p>
            <span className="strong">$499.99</span>
            <p className="text">You Will Save</p>
            <span className="strong">$98.8</span>
        </AlertModal>
    )
}

export const RenewalBothSuccessModalToAutoToAnnual = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Cycle Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal type to <span className="text">“Auto”</span> and renewal cycle to <span className="text">“Annual”</span> has been changed. You will be charged for Annual subscription after your current plan expiring on <span className="text">12/31/2020</span>.
            </p>
            <p className="text">Annual Subscription Charges</p>
            <span className="strong">$499.99</span>
            <p className="text">You Will Save</p>
            <span className="strong">$98.8</span>
        </AlertModal>
    )
}

export const RenewalBothConfirmModalToAutoToMonthly = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            className="confirm-modal"
            icon={confirmIcon}
            message="Change Renewal Type and Cycle?"
            showFooter={false}
            {...props}
        >
            <p className="subtitle">
                Are you sure to change renewal type to <span className="text">“Auto”</span> and renewal cycle <span className="text">“Annual”</span> to <span className="text">“Monthly”</span>? changing cycle will cost you <span className="text">$98.9</span> more in a year
            </p>
            <p className="text">Annual Subscription Charges</p>
            <span className="strong">$499.99</span>
            <p className="text">One year charge if paid monthly</p>
            <span className="strong">$598.8</span>
            <Button
                variant="primary"
                block
                size="md"
                onClick={() => props.onHide()}
            >Cancel Changes</Button>
            <Button
                variant="secondary"
                block
                size="md"
                onClick={() => props.onConfirm()}
            >Yes, Continue</Button>
        </AlertModal>
    )
}

export const RenewalBothSuccessModalToAutoToMonthly = ({
    ...props
}) => {
    return (
        <AlertModal
            size="sm"
            icon={successIcon}
            message="Renewal Type and Cycle Updated"
            btnText="Ok, Thanks"
            btnProps={{ variant: "link" }}
            className="success-modal"
            {...props}
        >
            <p className="subtitle">
                Your renewal type to <span className="text">“Auto”</span> and renewal cycle <span className="text">“Annual”</span> to <span className="text">“Monthly”</span> has been changed. You will be charged for Annual subscription after your current plan expiring on <span className="text">12/31/2020</span>.
            </p>
            <p className="text">Monthly charge after current plan expires will be</p>
            <span className="strong">$49.99</span>
        </AlertModal>
    )
}